import { makeStyles } from "@material-ui/core/styles";
import { MuiTheme } from "theme";

export default makeStyles((theme: MuiTheme) => ({
  listVirtualized: {
    width: "100%"
  },
  rowLink: {
    cursor: "pointer",
    textDecoration: "none",
    display: "grid",
    gridTemplateColumns: "40px 1fr",
    borderBottom: `1px solid #eeeeee`
  },
  row: {
    display: "grid",
    gridTemplateColumns: "65% 35%",
    alignItems: "center",
    justifyItems: "space-between",
    width: "100%",
    height: 60,
    paddingRight: 24,
    [theme.breakpoints.down("sm")]: {
      paddingRight: 16
    }
  },
  rowOdd: {
    backgroundColor: "#fafafa"
  },
  rowEven: {
    backgroundColor: theme.palette.common.white
  },
  icon: {
    height: 16,
    width: 16,
    color: theme.palette.text.hint,
    marginBottom: -2,
    marginRight: 10
  },
  name: {
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    color: theme.palette.text.primary
  },
  age: {
    fontSize: 14,
    lineHeight: "normal",
    textAlign: "right"
  },
  color: {
    fontSize: 14,
    fontFamily: "SuisseIntlMedium, SuisseIntlRegular",
    lineHeight: "normal",
    textAlign: "right",
    whiteSpace: "nowrap",
    direction: "rtl"
  }
}));
